function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4844 7C24.0156 7 24.4844 7.20312 24.8906 7.60938C25.2969 8.01563 25.5 8.48437 25.5 9.01562V22.9844C25.5 23.5156 25.2969 23.9844 24.8906 24.3906C24.4844 24.7969 24.0156 25 23.4844 25H9.51562C8.95312 25 8.47656 24.7969 8.08594 24.3906C7.69531 23.9844 7.5 23.5156 7.5 22.9844V19H9.51562V22.9844H23.4844V9.01562H9.51562V13H7.5V9.01562C7.5 8.48437 7.69531 8.01563 8.08594 7.60938C8.47656 7.20312 8.95312 7 9.51562 7H23.4844ZM14.5781 19.6094L17.1562 16.9844H7.5V15.0156H17.1562L14.5781 12.3906L15.9844 10.9844L21 16L15.9844 21.0156L14.5781 19.6094Z",
  fill: "#868686"
});

var SvgIcoExittoapp = function SvgIcoExittoapp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoExittoapp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-exittoapp.235b6885.svg";
export { ForwardRef as ReactComponent };